export const getVenueImage = (
  venue: { images?: { thumbnail?: string[]; regular?: string[] } },
  size = ' thumbnail'
) => {
  const { images: { thumbnail = [], regular = [] } = {} } = venue;

  return size === 'thumbnail' ? thumbnail[0] : regular[0];
};
